import React from 'react';

import CardBanner from '@components/CardBanner';
import { CustomRpcModal } from '@components/CustomRpcModal';
import SEO from '@components/SEO';
import WidgetHolder from '@components/WidgetHolder';

import { FarmsWidget } from './FarmsWidget';
import { BannerWrapper, Container } from './styled';

const FarmsView = () => {
  return (
    <>
      <SEO page="farms" />
      <CustomRpcModal />

      <WidgetHolder>
        <Container>
          <FarmsWidget />
        </Container>
      </WidgetHolder>

      <BannerWrapper>
        <CardBanner />
      </BannerWrapper>
    </>
  );
};

export default FarmsView;
